import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

var CoreLink = function CoreLink(_ref) {
  var to = _ref.to,
      title = _ref.title,
      className = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["to", "title", "className", "children", "onClick"]);

  var host = window.location.hostname;

  var isInternal = function (url) {
    if (/^internal:/.test(url)) {
      to = to.replace(/^internal:/, '');
      return true;
    }

    return false;
  }(to);

  var isEntity = function (url) {
    if (/^entity:/.test(url)) {
      to = to.replace(/^entity:/, '');
      return true;
    }

    return false;
  }(to);

  var isMailto = function isMailto(url) {
    return /^mailto:/.test(url);
  };

  var isPhoneLink = function isPhoneLink(url) {
    return /^tel:/.test(url);
  };

  var linkHost = function (url) {
    if (/^https?:\/\//.test(url)) {
      // Absolute URL.
      var parser = document.createElement('a');
      parser.to = url;
      return parser.hostname;
    } else {
      // Relative URL.
      return window.location.hostname;
    }
  }(to);

  if (!to) {
    if (children) {
      return /*#__PURE__*/React.createElement("a", {
        className: className
      }, children);
    }

    return /*#__PURE__*/React.createElement("a", {
      className: className
    }, title);
  }

  var onClickFunction = function onClickFunction(e) {
    if (onClick) {
      onClick(e);
    }
  }; // If mailto: or tel:, render a regular a tag and don't scroll the page.


  if (isPhoneLink(to) || isMailto(to)) {
    return /*#__PURE__*/React.createElement("a", _extends({}, props, {
      onClick: onClick,
      target: "_blank",
      rel: "noopener noreferrer",
      className: className,
      href: to
    }), children || title);
  }

  if ((!isInternal || !isEntity) && host !== linkHost) {
    if (children) {
      return /*#__PURE__*/React.createElement("a", _extends({}, props, {
        onClick: onClickFunction,
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        href: to
      }), children);
    } else {
      return /*#__PURE__*/React.createElement("a", _extends({}, props, {
        onClick: onClickFunction,
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        href: to
      }), title);
    }
  } else if (children) {
    return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
      onClick: onClickFunction,
      className: className,
      to: to
    }), children);
  } else {
    return /*#__PURE__*/React.createElement(Link, _extends({}, props, {
      onClick: onClickFunction,
      className: className,
      to: to
    }), title);
  }
};

export default CoreLink;